<app-features-container
  header="{{ '+INSTALLATIONS.INSTALLATION.GATEWAY.TITLE' | translate }}"
  [overlayType]="availableOverlays.Gateway"
  [isMoreActions]="
    (status$ | async | ready)?.properties?.online?.value ||
    (authStore.hasOneOfUserIotRoles(rsaRolesForDeregister) | async)
  "
>
  <app-banner
    *ngIf="isFirmwareOutdated$ | async"
    feature
    class="update-banner"
    type="warning"
    isFullWidth="true"
    [title]="'+GENERAL.ACTION_REQUIRED' | translate"
    [linkLabel]="'+INSTALLATIONS.INSTALLATION.OPEN_UPDATE' | translate"
    (clickEvent)="openUpdateTile()"
  >
    {{ '+INSTALLATIONS.INSTALLATION.GATEWAY_UPDATE_AVAILABLE' | translate }}
  </app-banner>

  <!-- gatewaySerial -->
  <app-feature-tile
    *ngIf="gatewayProperties$ | async as gateway"
    feature
    data-at-gateway-serial
    label="{{ (gatewayType$ | async) || translateService.instant('+GENERAL.GATEWAY') }}"
    value="{{ gateway?.serial | dash }}"
    isFullWidth="true"
  ></app-feature-tile>

  <!-- no gatewaySerial -->
  <app-feature-tile
    *ngIf="!(gatewayProperties$ | async)"
    feature
    label="{{ '+INSTALLATIONS.INSTALLATION.COMMUNICATION_MODULE.TITLE' | translate }}"
    value="{{ '' | dash }}"
    isFullWidth="true"
  ></app-feature-tile>

  <!-- gateway.status -->
  <app-feature-tile
    *ngIf="status$ | async | ready as feature"
    feature
    data-at-gateway-status
    label="{{ '+INSTALLATIONS.INSTALLATION.GATEWAY_PROPERTIES.STATUS.TITLE' | translate }}"
    value="{{ feature?.properties?.online?.value | translateStatus | dash }}"
    [class.full-width]="!(gatewayStore.isWifiEnabled$ | async)"
    [attr.data-feature]="feature?.feature"
  ></app-feature-tile>
  <ng-container *ngrxLet="featureConnectionMode$ as feature" feature>
    <ng-container *ngIf="!feature; then noWifiStrength"></ng-container>
    <ng-container
      *ngIf="feature?.properties?.mode?.value === GatewayConnectionMode.ethernet; else notLanMode"
    >
      <!-- LAN mode enabled -->
      <app-feature-tile
        data-at-ethernet
        feature
        label="{{ '+INSTALLATIONS.INSTALLATION.LAN_MODE.TITLE' | translate }}"
        value="{{ feature | value2: featurePropertyKey.mode | gatewayConnectionMode }}"
        [attr.data-feature]="feature?.feature"
      >
      </app-feature-tile>
    </ng-container>
    <ng-template #notLanMode>
      <!-- gateway.wifi -->
      <ng-container *ngIf="feature?.properties?.mode?.value === GatewayConnectionMode.wifi" feature>
        <app-feature-tile
          *ngIf="wifi$ | async | ready as feature; else noWifiStrength"
          data-at-wifi-strength
          label="{{ '+INSTALLATIONS.INSTALLATION.WIFI_STRENGTH.TITLE' | translate }}"
          informationTooltip="{{ this.dbmRangeTooltipText() }}"
          value="{{ feature.properties?.strength?.value | translateWifiStrength }} {{
            feature | value2: featurePropertyKey.strength | suffix: SUFFIX.decibelMilliWatt
          }}"
          [attr.data-feature]="feature?.feature"
          [error]="
            (feature | error) ||
            (feature.properties?.strength &&
              feature?.properties?.strength?.value <= wifiSignalThreshold)
          "
          [class.wifi-warning]="
            feature.properties?.strength &&
            feature?.properties?.strength?.value <= wifiSignalThreshold
          "
          [iconVariant]="iconVariant.error"
        ></app-feature-tile>
      </ng-container>
    </ng-template>
    <!-- no wifi -->
    <ng-template #noWifiStrength>
      <app-feature-tile
        feature
        label="{{ '+INSTALLATIONS.INSTALLATION.WIFI_STRENGTH.TITLE' | translate }}"
        value="{{ NO_VALUE }}"
        [attr.data-feature]="feature?.feature"
      >
      </app-feature-tile>
    </ng-template>
  </ng-container>

  <ng-container more-menu>
    <app-gateway-menu
      [gatewaySerial]="gatewaySerial"
      [installationId]="installationId"
    ></app-gateway-menu>
  </ng-container>
</app-features-container>
